angular.module("app").constant("pageStatuses", [
    "published",
    "inactive",
    "archive"
]);

angular.module("app").constant("pageTypes", [
    "news",
    "sidebar",
    "text",
    "category"
]);

angular.module("app").constant("aligns", [
    "l1",
    "l2",
    "r1",
    "r2"
]);

angular.module("app").constant("targets", [
    "_blank",
    "_self"
]);

angular.module("app").constant("casinoGameTypes", [
    'is_mobile',
    'is_real_play',
    'is_download',
    'is_target',
    'is_for_fun',
    'is_corrupted',
    'is_view_mode',
    'maintenance'
]);

angular.module("app").constant("ratios", [
    '3:4',
    '4:3',
    '16:9',
    'Custom'
]);

angular.module("app").constant("dateRangeConstants", [
    {
        name: "1 hour",
        value: 3600
    },
    {
        name: "3 hours",
        value: 10800
    },
    {
        name: "5 hours",
        value: 18000
    },
    {
        name: "1 day",
        value: 86400
    },
    {
        name: "3 days",
        value: 259200
    },
    {
        name: "5 days",
        value: 432000
    },
    {
        name: "1 week",
        value: 604800
    }
]);

